import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { chatService } from '../services/chatService'

export const currentActiveMessages = createAsyncThunk(
  'chat/getMessages',
  async (data, { rejectWithValue }) => {
    try {
      const response = await chatService.fetchUserMessages(data)
      return response
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  },
)

const initialState = {
  data: [],
  singleData: {},
  loading: false,
  error: false,
  message: '',
}

const slice = createSlice({
  name: 'chat',
  initialState,
  reducers: {
    checkAll: (state) => {
      state.isChecked = !state.isChecked
    },
    resetSingleData: (state) => {
      state.singleData = {}
    },
  },
  extraReducers: {
    [currentActiveMessages.pending]: (state) => {
      state.loading = true
    },
    [currentActiveMessages.fulfilled]: (state, { payload }) => {
      state.message = payload?.message
      state.loading = false
      state.singleData = payload
    },
    [currentActiveMessages.rejected]: (state, { payload }) => {
      state.error = true
      state.message = payload
      state.loading = false
    },
  },
})

export const { resetSingleData } = slice.actions
export default slice.reducer
